<div class="main" >
  <div class="logo">
    <img src="assets/SmartTruck-Logo-Color.svg" alt="">
  </div>
  <div class="message">
    <span>
      {{message}}
    </span>
  </div>
</div>